export default "__VITE_ASSET__DbIXIq7p__"